import { PropsWithChildren, useEffect } from 'react';

import { attachComponentData } from '@backstage/core-plugin-api';

import { PageLayout } from '@spotify/confidence-core-react';
import { PageImpression } from '@spotify/plugin-confidence-tracking-react';

import { useFavoritesCollection } from '../../hooks/useFavoritesCollection';
import { favoritesRouteRef } from '../../routes';
import { CollectionEntriesList } from '../CollectionPage/CollectionEntriesList';

export const FavoritesPage = ({ children }: PropsWithChildren) => {
  const { favoritesCollectionName, ensureCollection } =
    useFavoritesCollection();

  useEffect(() => {
    ensureCollection();
  }, [ensureCollection]);

  return (
    <PageImpression pageId="favorites">
      <PageLayout
        enableMargin
        title="Favorites"
        isLoading={!favoritesCollectionName}
      >
        {favoritesCollectionName && (
          <CollectionEntriesList
            collectionName={favoritesCollectionName}
            isFavorites
          />
        )}
        {children}
      </PageLayout>
    </PageImpression>
  );
};

// attachComponentData is the Backstage-supported way to bind a route ref to a
// plain component used in FlatRoutes. Migrate to PageBlueprint when the admin
// plugin provides favorites as an extension point.
attachComponentData(FavoritesPage, 'core.mountPoint', favoritesRouteRef);
